import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { PageBody } from "@/components/ui/layout"
import { useTranslation } from "react-i18next"
import { ClipboardCheck } from "lucide-react"
import { ActionButton } from "@/components/shared/action-buttons"
import { useEditProps } from "./page-props"
import { SheetPage, SheetPageTrigger } from "@/components/ui/sheet-page"
import { Preferences } from "@/components/learners/preferences/preference-page"
import type { ShortlistSheetProps } from "@/components/learners/preferences/shortlist-sheet"
import { useNavigate, usePathParam } from "@/lib/page-rendering"
import { useCallback, useState } from "react"
import { Provider } from "react-redux"
import {
  createPageStore,
  PageReduxContext,
} from "@/components/learners/preferences/store"

export default function Page() {
  const navigate = useNavigate()
  const { t } = useTranslation("preference_templates")
  const school_id = usePathParam("schoolId")
  const templateId = usePathParam("id")
  const { template, added_preference_id } = useEditProps()

  const [store] = useState(
    createPageStore({
      href: `/learners/schools/${school_id}/preference_templates/${templateId}`,
      data: {},
    }),
  )

  const addPreference = useCallback<ShortlistSheetProps["onSelect"]>(
    ({ signedIdentifier, subjectId }, teacherId) => {
      navigate({
        href: `/learners/preferences`,
        method: "post",
        data: {
          preference: {
            es_teacher_id: teacherId,
            signed_identifier: signedIdentifier,
            subject_id: subjectId,
            school_id,
            preference_template_id: templateId,
          },
        },
        replace: true,
      })
    },
    [navigate, school_id, templateId],
  )
  const addedPreferenceId =
    added_preference_id === null ? null : Number(added_preference_id)

  return (
    <Provider store={store} context={PageReduxContext}>
      <LearnerPageChrome
        action={
          <SheetPage
            href={`/learners/schools/${school_id}/preference_templates/${templateId}/application/new`}
          >
            <SheetPageTrigger asChild>
              <ActionButton variant="solid" Icon={ClipboardCheck}>
                {t("applications.new.apply")}
              </ActionButton>
            </SheetPageTrigger>
          </SheetPage>
        }
      />
      <PageBody>
        <Preferences
          addedPreferenceId={addedPreferenceId}
          preferences={template}
          store={store}
          onSelectClass={addPreference}
        />
      </PageBody>
    </Provider>
  )
}
